<template>
<div class="instory">
    <template>
        <p class="child-title">技术动态</p>
        <p class="child-sub-title">TECHNOLOGY TRENDS</p>
        <ul>
            <router-link :to="{path:'/news-detail',query:{id:item.id}}" tag="li" v-for="(item, index) in datas.data" :key="index">
                <img :src="item.image" alt srcset />
                <div>
                    <p class="name">{{item.name}}</p>
                    <p class="date">{{item.date}}</p>
                    <p class="desc">{{item.summary}}</p>
                </div>
            </router-link>
        </ul>
        <el-pagination :page-size="6" background layout="prev, pager, next" :total="datas.total" @current-change="change"></el-pagination>
    </template>
</div>
</template>

<script>
import {
    article
} from "../../assets/js/api";
export default {
    data() {
        return {
            datas: {},
            page: 1,
        };
    },
    created() {
        if (this.$route.query.id) {
            setTimeout(() => {
                this.$router.push({
                    path: "/news/company/detail",
                });
            }, 100);
        } else {
            this.getData();
        }
    },
    methods: {
        change(e) {
            this.page = e;
            this.getData();
        },
        getData() {
            article({
                limit: 6,
                page: this.page,
                where: {
                    type: 2,
                },
            }).then((r) => {
                this.datas = r.data;
            });
        },
    },
};
</script>

<style lang="less" scoped>
ul {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    li {
        width: 48%;
        margin-bottom: 0.18rem;

        img {
            width: 100%;
            height: 2.96rem;
            vertical-align: middle;
        }

        div {
            height: 2.2rem;
            padding-top: 0.19rem;
            background: #f3f3f3;
        }

        p {
            padding: 0 0.26rem;
            box-sizing: border-box;
        }

        .name {
            font-size: 0.28rem;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            height: .8rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        .date {
            font-size: 0.14rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #999999;
            margin: 0.22rem 0;
        }

        .desc {
            font-size: 0.2rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #555555;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    }
}

.el-pagination {
    margin-top: 0.98rem;
}
</style>
